// extracted by mini-css-extract-plugin
export default {"root":"_1p8Fk","small":"_2-1iO","normal":"_3phdM"};